import bundled from 'virtual:assist-packs';
/**
 * Content packs ship inside the app build, so decision support works with no network. Which ones
 * a facility uses, and whether it may see rules not yet clinically approved, is set per facility
 * by an administrator on the server and cached on the device.
 */
import type { Pack } from '@assist/core';

export interface PackSetting {
  packId: string;
  enabled: boolean;
  allowDraft: boolean;
}

export const allPacks: Pack[] = bundled;

export interface ActivePack {
  pack: Pack;
  allowDraft: boolean;
}

export function activePacks(settings: PackSetting[]): ActivePack[] {
  return allPacks.flatMap((pack) => {
    const s = settings.find((x) => x.packId === pack.id);
    return s?.enabled ? [{ pack, allowDraft: s.allowDraft }] : [];
  });
}
